import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import {Row, Col} from '../../../shared/packages/Grid';
import FeedContainer from './FeedContainer.jsx';
import FeedItemSingle from './FeedItemSingle.jsx';
import FeedItem from './FeedItem.jsx';

class Feed extends Component {
  render() {
    const {
      feedData
    } = this.props;

    const releaseNotes = _.concat([], _.get(feedData, 'releaseNotes.topics[0]', []));
    const features = _.get(feedData, 'features.topics');
    const issues = _.get(feedData, 'issues.topics');

    const communityData = _.concat([], releaseNotes, features, issues);

    return (
      <Row>
        <Col xs={12}>
          {communityData && communityData.length > 0 &&
            <div className="community-feed">
              {releaseNotes && releaseNotes.length > 0 && releaseNotes.map((item, index) =>
                <FeedItemSingle
                  key={index}
                  item={item}
                />
              )}
              {features && features.length > 0 &&
                <FeedContainer items={features}>
                  {features.map((item, index) =>
                    <FeedItem
                      key={index}
                      item={item}
                    />
                  )}
                </FeedContainer>
              }
              {issues && issues.length > 0 &&
                <FeedContainer items={issues}>
                  {issues.map((item, index) =>
                    <FeedItem
                      key={index}
                      item={item}
                    />
                  )}
                </FeedContainer>
              }
            </div>
          }
        </Col>
      </Row>
    );
  }
}

Feed.propTypes = {
  feedData: PropTypes.object
};

export default Feed;



/** WEBPACK FOOTER **
 ** ./client/components/Omni/OmniSales/Feed.jsx
 **/